<template>
    <div id="fleets-view" class="view">
        <settings-menu></settings-menu>

        <drivers-table table-title="Drivers"></drivers-table>
    </div>
</template>

<script>
import SettingsMenu from '@/components/layout/SettingsMenu'
import DriversTable from '@/views/Drivers/components/DriversTable'

const body = document.body

export default {
    name: 'Drivers',
    mounted () {
        body.classList.add('devices-view')
    },
    beforeDestroy () {
        body.classList.remove('devices-view')
    },
    components: {
        DriversTable,
        SettingsMenu
    }
}
</script>

<style scoped>

</style>
